import type {CaseReducer, PayloadAction} from '@reduxjs/toolkit'

import type {NotificationDto} from '../../services/pipelinesApi.types'

import type {PipelineDraftState} from './EditPipelinePage.slices.types'
import {deleteIfEmpty} from './EditPipelinePage.slices.utils'

export const addNotification: CaseReducer<
  PipelineDraftState,
  PayloadAction<{id: string; notification: NotificationDto}>
> = (state, action) => {
  const notification = action.payload.notification
  const id = action.payload.id ?? 0
  const {draft} = state[id] ?? {}
  const notificationId: number = draft?.notifications ? draft.notifications.length - 1 : 0

  if (draft != null) {
    draft.notifications ??= []
    draft.notifications.push(notification)
    state[id]!.added ??= {}
    state[id]!.added!.notifications ??= {}
    state[id]!.added!.notifications![notificationId] = true
  }
}

export const updateNotification: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    notificationId: string
    notificationData: Partial<NotificationDto>
  }>
> = (state, action) => {
  const {id, notificationId, notificationData} = action.payload
  const notifications = state[id]?.draft?.notifications ?? []
  if (notifications && notificationId) {
    const notificationIndex = notificationId ? Number(notificationId) : -1
    if (notificationIndex !== -1) {
      notifications[notificationIndex] = {
        ...notifications[notificationIndex],
        ...notificationData,
      }
    }
  }
}

export const deleteNotification: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    notificationId: string
  }>
> = (state, action) => {
  const {id, notificationId} = action.payload

  state[id] ??= {}
  state[id]!.deleted ??= {}
  state[id]!.deleted!.notifications ??= []
  state[id]!.deleted!.notifications.push(notificationId)
}

export const restoreNotification: CaseReducer<
  PipelineDraftState,
  PayloadAction<{
    id: string
    notificationId: string
  }>
> = (state, action) => {
  const {id, notificationId} = action.payload
  const deleted = state[id]?.deleted?.notifications
  if (deleted?.includes(notificationId)) {
    deleted.splice(
      deleted.findIndex(n => n === notificationId),
      1,
    )

    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    deleteIfEmpty(state[id]!.deleted, 'notifications') && deleteIfEmpty(state[id], 'deleted')
  }
}
